import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import '../../queries/book-appointment.js';
import '../../queries/book-appointment-by-id.js';
import '../../queries/get-availability-stores-nearby.js';
import '../../queries/get-user.js';
import '../../queries/get-calendar-availability.js';
import { GET_CALENDAR_AVAILABILITY_BY_ID } from '../../queries/get-calendar-availablility-by-id.js';
import '../../queries/get-store-offer-by-code.js';
import '../../queries/get-store-offer-by-id.js';
import '../../queries/get-store-opening-times.js';
import '../../queries/get-store-opening-times-by-id.js';
import '../../queries/get-time-slots.js';
import '../../queries/get-time-slots-by-id.js';
import { toLocalDate, toLocalTimeMinutes } from '../../utils/datetime.js';
import '@swc/helpers';
import '@grandvisionhq/stores-v2';
import { fromCalendarAvailabilityByIdQueryToCalendarAvailability } from './adapters/fromCalendarAvailabilityByIdQueryToCalendarAvailability.js';

const useCalendarAvailabilityById = ()=>{
    const [query, queryState] = useLazyQuery(GET_CALENDAR_AVAILABILITY_BY_ID, {
        fetchPolicy: 'no-cache',
        context: {
            timeout: 10000
        }
    });
    const getCalendarAvailability = React.useCallback(({ appointmentTypeId , globalStoreId , startDate , endDate , startTime , endTime  })=>{
        query({
            variables: {
                appointmentTypeIds: [
                    appointmentTypeId
                ],
                globalStoreIds: [
                    globalStoreId
                ],
                startDate: toLocalDate(startDate),
                endDate: toLocalDate(endDate),
                startTime: startTime ? toLocalTimeMinutes(startTime) : undefined,
                endTime: endTime ? toLocalTimeMinutes(endTime) : undefined
            }
        });
    }, [
        query
    ]);
    const data = React.useMemo(()=>fromCalendarAvailabilityByIdQueryToCalendarAvailability(queryState.data)
    , [
        queryState.data
    ]);
    const { called , error , loading  } = queryState;
    return React.useMemo(()=>[
            getCalendarAvailability,
            {
                called,
                loading,
                data,
                error
            }
        ]
    , [
        getCalendarAvailability,
        called,
        loading,
        data,
        error
    ]);
};

export { useCalendarAvailabilityById as default };
//# sourceMappingURL=use-calendar-availability-by-id.js.map
